import { debounce } from 'lodash';

let debouncedUpdatePageData;

const plugin = config => ({
  initialize: ({ getProps }) => {
    const { page } = getProps();
    debouncedUpdatePageData = debounce(page.updatePageData, 250);
  },
  onChange: (editorState, { getProps }) => {
    // console.log('onChange', blockType, dataKey);
    const { readOnly } = getProps();
    if (readOnly) return editorState;
    const { page } = getProps();
    const contentState = editorState.getCurrentContent();
    const blockMap = contentState.getBlockMap();
    const data = config.reduce((acc, [blockType, key]) => {
      const block = blockMap.find(b => b.getType() === blockType);
      if (block) {
        const text = block.getText();
        if (page.data[key] !== text) {
          acc[key] = text;
        }
      }
      return acc;
    }, {});
    if (Object.keys(data).length > 0) {
      debouncedUpdatePageData(data);
    }
    // console.log(data);
    return editorState;
  },
});

export default plugin;
